import moment from 'moment';

export const errorContent = (code, data) => {
  switch (code) {
    case 401: return {
      message: 'The user is unauthenticated',
      btn1: 'Go to Login Page',
      action1: 0
    };
    case 404: return {
      message: 'Not found',
      btn1: 'Restart',
      action1: 1,
      btn2: 'Go Back',
      action2: 2
    };
    case 500: return {
      message: 'Oops! Something has gone wrong.',
      btn1: 'Restart',
      action1: 1,
      btn2: 'Go Back',
      action2: 2
    };
    case 501: return {
      message: 'Oops! Something has gone wrong.',
      btn1: 'Restart',
      action1: 1,
      btn2: 'Go Back',
      action2: 2
    };
    case 502: return {
      message: 'Oops! Something has gone wrong.',
      btn1: 'Restart',
      action1: 1,
      btn2: 'Go Back',
      action2: 2
    };
    case 503: {
      let message = 'Service is temporarily unavailable, please try again later.';
      let reloadTime = 59;

      if (data && data.retry_after) {
        const retry = data.retry_after;

        if (!retry.includes('GMT')) {
          reloadTime = retry - 1;
          message = `Service is in maintenance mode. We will be back in ${retry / 60} minutes.`;
          setTimeout(() => window.location.reload(), retry * 1000);
        } else {
          reloadTime = null;
          message = `Service is in maintenance mode. We will be back at: ${moment(retry).format('MMM D, \'YY hh:mm')}.`;
          setTimeout(() => window.location.reload(), Math.abs(new Date(retry) - new Date()));
        }
      } else {
        setTimeout(() => window.location.reload(), 60 * 1000);
      }

      return {
        message,
        btn1: 'Reload',
        action1: 1,
        btn2: '',
        action2: null,
        reloadTime
      };
    }
    case 504: return {
      message: 'Servers didn\'t respond in timely manner. We may be overloaded. Please try using app later.',
      btn1: 'Restart',
      action1: 1,
      btn2: 'Go Back',
      action2: 2
    };
    default: return { message: 'Unknown error', btn1: 'Restart', action1: 1 };
  }
};